module.exports = __webpack_public_path__ + "image-placeholder.c6c07d14335ff03a9a6503bfc789f206.hashedasset.svg";